import React from 'react';
import {Box, Typography, useTheme} from '@mui/material';

export default function CustomerContextPanel({paymentTrackRecord}) {
    const theme = useTheme();
    const customerSince = paymentTrackRecord.customerSince || 'Sin dato';

    return (
        <Box sx={{border: `1px solid ${theme.palette.divider}`, borderRadius: '8px', p: 2}}>
            <Typography variant="subtitle2" sx={{mb: 1}}>Cliente</Typography>
            <SummaryLine label="Cliente desde" value={customerSince}/>
            <SummaryLine label="Facturas pagadas" value={paymentTrackRecord.paidInvoices}/>
            <SummaryLine label="Pagos atrasados" value={paymentTrackRecord.latePaidInvoices}/>
            <SummaryLine label="Facturas por vencer" value={paymentTrackRecord.upcomingInvoices}/>
        </Box>
    );
}

function SummaryLine({label, value}) {
    return (
        <Box sx={{display: 'flex', justifyContent: 'space-between', py: 0.5}}>
            <Typography variant="body2">{label}</Typography>
            <Typography variant="body2" sx={{fontWeight: 600}}>{value}</Typography>
        </Box>
    );
}
